export default {
  meta: {
    title: '拓店管理-无意义',
  },
};
